import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Controla lanseras på Microsoft och Google marketplaces",
  header: "Controla lanseras på Microsoft och Google marketplaces",
  date: "2025-10-15",
  description:
    "Vårt cybersäkerhetsverktyg finns nu direkt i Microsoft Store och Google Workspace Marketplace – så att småföretag kan komma igång snabbare och enklare.",
  category: "företag",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
